module.exports = __webpack_public_path__ + "static/media/ChickenFishSteak.6c2ad029.mov";